import {Text} from '@ui-kitten/components';
import {StyleSheet} from 'react-native';
import {Button, Card, Modal} from '@ui-kitten/components';
import React from 'react';
import {useNavigation} from '@react-navigation/native';
import {AUTHENTICATED_ROUTES} from '../../navigation/constants';
import {px} from '../../utils';

export const PaymentErrorModal = () => {
  const [visible, setVisible] = React.useState(true);

  const navigation = useNavigation();

  const onConfirm = () => {
    setVisible(false);
    navigation.navigate(AUTHENTICATED_ROUTES.main.path);
  };

  return (
    <Modal
      visible={visible}
      backdropStyle={styles.backdrop}
      onBackdropPress={() => onConfirm()}>
      <Card style={styles.modalContainer} disabled={true}>
        <Text style={styles.errorText}>
          Your payment session is expired, {'\n'}please try again!
        </Text>
        <Button onPress={() => onConfirm()}>{'Okay'}</Button>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    paddingHorizontal: px(15),
    paddingVertical: px(20),
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  errorText: {
    fontSize: px(20),
    marginBottom: px(20),
    textAlign: 'center',
  },
});
